import { Component, OnInit, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import { MatDialog } from '@angular/material';

import { MessageFormComponent } from '../message-form/message-form.component';
import { MessageDialog } from './message-dialog/message-dialog.component';

@Component({
  selector: 'app-user-pm',
  templateUrl: './user-pm.component.html',
  styleUrls: ['./user-pm.component.scss'],
  providers: [AngularFireAuth, AngularFireDatabase]
})
export class UserPMComponent implements OnInit {
  messages : Observable<any[]>;
  user : any;
  subscriptions : any[] = [];

  constructor(public afAuth : AngularFireAuth,
              public dialog : MatDialog,
              private db : AngularFireDatabase,
              private router : Router,
              private route : ActivatedRoute) { }

  ngOnInit() {
    let authSub = this.afAuth.auth.onAuthStateChanged(user => {
      this.messages =
        this.db.list('messages', ref => ref.orderByChild('toId').equalTo(user.uid))
        .valueChanges();
    });

    let routeSub = this.route.params.subscribe(params => {
      if (params.id) {
        let subscription = this.db.object(`messages/${params.id}`)
          .valueChanges().subscribe(snapshot => {
            let messageDialog = this.dialog.open(MessageDialog,
              { data: { message: snapshot } }
            );
          });
      }
    });

    this.subscriptions.push([routeSub, authSub])
  }

}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/users/user-pm/user-pm.component.ts